import { lazy } from "react";
import { RouteObject } from "react-router-dom";

// Journal routes
const JournalPage = lazy(() => import("@/shared/journal/pages"));
const JournalDetailsPage = lazy(
  () => import("@/shared/journal/pages/journal-details")
);
const CreateJournalPage = lazy(
  () => import("@/shared/journal/pages/create-journal")
);
const EditJournalPage = lazy(
  () => import("@/shared/journal/pages/create-journal")
);

export const journalRoutes: RouteObject[] = [
  {
    path: "/journal",
    element: <JournalPage />,
  },
  {
    path: "/journal/:journalId",
    element: <JournalDetailsPage />,
  },
  {
    path: "/journal/create",
    element: <CreateJournalPage />,
  },
  {
    path: "/journal/:id/edit",
    element: <EditJournalPage />,
  },
];
